import React, { FC } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import {
    StandardModalBody,
    StandardModalHeader,
} from "../../../general/Modal/Modal";
import {
    GridTable,
    GridTableHeader,
} from "../../../general/Tables/GridTable/GridTable";
import { UploadingDocumentPlaceholder } from "../../../documents/lib";
import { UploadReceiptRow } from "../uploader/UploadedReceiptRow";
import styles from "./DocumentsModal.module.scss";

interface DocumentsModalProps {
    items: UploadingDocumentPlaceholder[];
    onRemove: (item: UploadingDocumentPlaceholder) => void;
    onDetails: (item: UploadingDocumentPlaceholder) => void;
}

export const DocumentsModal: FC<DocumentsModalProps> = ({
    items,
    onRemove,
    onDetails,
}) => (
    <>
        <StandardModalHeader>All documents</StandardModalHeader>

        <Scrollbars
            autoHeight
            autoHeightMin={400}
            style={{ maxHeight: "calc(100vh - 100px)" }}
        >
            <StandardModalBody className="p-0">
                <GridTable className={styles.table}>
                    <GridTableHeader>
                        <div>Name</div>
                        <div>Status</div>
                        <div />
                        {/* Empty div for actions */}
                    </GridTableHeader>

                    {items.map((item) => (
                        <UploadReceiptRow
                            item={item}
                            onRemove={() => onRemove(item)}
                            onRowClick={() => onDetails(item)}
                            key={item.financialDocument?.id ?? item.fileName}
                        />
                    ))}
                </GridTable>
            </StandardModalBody>
        </Scrollbars>
    </>
);
